module.exports = __webpack_public_path__ + "static/media/Inter-Bold.231f444d.woff2";